/* FRENGIDIS Welcome Popup — delayed, frequency-capped, dismissible. */
(() => {
  if (window.__frengidisWelcomePopupScript) return;
  window.__frengidisWelcomePopupScript = true;
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const isEditor = () => Boolean(window.Shopify && window.Shopify.designMode);
  const hasSeen = (key, days) => {
    try {
      const last = Number(window.localStorage.getItem(key));
      if (last > 0 && Date.now() - last < days * MS_PER_DAY) return true;
    } catch (_) {}
    try { return window.sessionStorage.getItem(key) === 'seen'; }
    catch (_) { return false; }
  };
  const markSeen = (key) => {
    try { window.localStorage.setItem(key, String(Date.now())); } catch (_) {}
    try { window.sessionStorage.setItem(key, 'seen'); } catch (_) {}
  };
  function setup(dialog) {
    if (dialog.dataset.fgwInitialized === 'true') return;
    dialog.dataset.fgwInitialized = 'true';
    if (typeof dialog.showModal !== 'function') return;
    const key = dialog.dataset.fgwStorageKey || 'frengidis-welcome-popup';
    const days = Math.max(1, Math.min(30, Number(dialog.dataset.fgwRepeatDays) || 7));
    if (!isEditor() && hasSeen(key, days)) return;
    dialog.querySelectorAll('[data-fgw-close]').forEach((button) => {
      button.addEventListener('click', () => dialog.close('dismiss'));
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close('dismiss');
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('fgw-is-open');
    });
    const requestedDelay = Number(dialog.dataset.fgwDelay) || 7000;
    let delay = Math.max(3000, Math.min(15000, requestedDelay));
    if (window.matchMedia('(max-width: 749px)').matches) delay += 2000;
    if (isEditor()) delay = 800;
    const open = () => {
      if (!dialog.isConnected || document.visibilityState !== 'visible') return;
      if (document.querySelector('dialog[open]')) return;
      const focused = document.activeElement;
      if (focused && focused.matches('input, textarea, select, [contenteditable="true"]')) return;
      try {
        dialog.showModal();
        document.documentElement.classList.add('fgw-is-open');
        dialog.querySelector('[data-fgw-close]')?.focus({ preventScroll: true });
        if (!isEditor()) markSeen(key);
      } catch (_) {
        // Never interfere with an existing modal or checkout experience.
      }
    };
    const timer = window.setTimeout(open, delay);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target && event.target.contains(dialog)) {
        window.clearTimeout(timer);
        if (dialog.open) dialog.close();
      }
    });
  }
  function initialize() {
    document.querySelectorAll('dialog[data-fgw-popup]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
